module.exports = __webpack_public_path__ + "static/img/loding_img.bf04ffe3.svg";